import React from 'react';
import {useTranslation} from 'react-i18next';
import {toPriceStr} from '@/components/utils/converter';
import {InviteRechargeRule} from '../../agent.type';

interface RewardRulesListProps {
  rewardRules: InviteRechargeRule[];
}

const RewardRulesList: React.FC<RewardRulesListProps> = ({rewardRules}) => {
  const {t} = useTranslation();

  // 根据 minFirstDeposit 排序规则列表
  const sortedRules = [...rewardRules].sort(
    (a, b) => a.minFirstDeposit - b.minFirstDeposit,
  );

  return (
    <div className="content-stretch flex flex-col items-start relative shrink-0 w-full">
      {/* 表头 */}
      <div className="bg-[#d8e2e7] box-border content-stretch flex gap-2 h-8 items-center px-3 py-0 relative shrink-0 w-full">
        <div className="basis-0 content-stretch flex gap-1 grow items-center min-h-px min-w-px relative shrink-0">
          <p className="capitalize leading-[normal] not-italic relative shrink-0 text-[#45454d] text-xs text-nowrap whitespace-pre">
            {t('agent.invitation-reward.taskConditions')}
          </p>
        </div>
        <div className="content-stretch flex gap-1 items-center justify-end relative shrink-0 w-[5rem]">
          <p className="capitalize leading-[normal] not-italic relative shrink-0 text-[#45454d] text-xs text-nowrap text-right whitespace-pre">
            {t('agent.invitation-reward.gear')}
          </p>
        </div>
      </div>

      {/* 任务列表 */}
      <div className="content-stretch flex flex-col items-start relative shrink-0 w-full">
        {sortedRules.map((rule, index) => (
          <div
            key={rule.id}
            className={`box-border capitalize content-stretch flex gap-2 h-10 items-center leading-[normal] not-italic px-3 py-0 relative shrink-0 text-[#45454d] text-sm w-full ${
              index % 2 === 0 ? 'bg-white' : 'bg-[#f1f5f8]'
            }`}>
            <p className="basis-0 grow min-h-px min-w-px relative shrink-0">
              {t('agent.invitation-reward.rechargeAmount')} ≥{' '}
              {toPriceStr(rule.minFirstDeposit)}
            </p>
            <p className="relative shrink-0 text-right w-[5rem]">
              {toPriceStr(rule.rewardAmount)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RewardRulesList;
